import { unsyncedSaleService } from '../../services';
import { checkIfSignedInAndOnline } from '../utils';

export async function unsyncedSalesJobHandler() {
    const shouldRun = checkIfSignedInAndOnline();

    if (!shouldRun) {
        return;
    }

    await unsyncedSaleService.syncPendingSales();
}
